import { makeWidgetProps, asWidgetProps } from 'Src/types/widget-helpers';
import React, { ComponentProps } from 'react';
import { ID_LAYER_HEADER__CA__TRANSFERS } from 'Components/utils/identifiers/constants';
import { LAYER_NAME_UPSELL_TRANSFERS } from 'Components/utils/layers/layers.constants';
import { t } from 'Src/i18n';
import { ClosableLayer } from 'Components/widgets/layer/ClosableLayer';
import { StayLayerHeader } from 'Components/widgets/stay-layer-header/StayLayerHeader';
import { TransfersLayerConnected } from './TransfersLayer';
type Props = PropsWithPageTracking<{
  forwardRef: ReactRef;
  stay: StayEntity;
}>;
export const TransfersLayerContainer = ({
  forwardRef,
  stay = makeWidgetProps<StayEntity>({}),
  tracking,
}: Props) => {
  const transfers = stay.upsells?.transfers ?? [];
  const title = t('stays.linkLabels.upsells.addTranferLabel');
  return (
    <ClosableLayer
      {...asWidgetProps<ComponentProps<typeof ClosableLayer>>({
        ariaLabel: title,
        ariaLabelledby: ID_LAYER_HEADER__CA__TRANSFERS,
        externalFocusTrapRefs: [forwardRef],
        hasAnimateEnter: true,
        header: (
          <StayLayerHeader
            {...asWidgetProps<ComponentProps<typeof StayLayerHeader>>({
              id: ID_LAYER_HEADER__CA__TRANSFERS,
              stay: stay,
              title: title,
            })}
          />
        ),
        name: LAYER_NAME_UPSELL_TRANSFERS,
        params: ['id', 'stayId'],
        tracking: tracking,
      })}
    >
      <TransfersLayerConnected
        {...asWidgetProps<ComponentProps<typeof TransfersLayerConnected>>({
          bookingId: stay.booking.id,
          stayIndex: stay.stayIndex,
          availableTransfers: transfers,
        })}
      />
    </ClosableLayer>
  );
};
